import HelpModal from 'features/Header/children/HelpModal/HelpModal';
import TopBar from 'features/Header/children/TopBar/TopBar';
import IdentityPanel from 'features/IdentityPanel/IdentityPanel';
import React, { ReactElement } from 'react';
import LowerTopBar from './children/LowerTopbar/LowerTopBar';
import { useWindowWidth } from 'shared-state/display-options/hooks';
import { useIdentityClaims } from 'shared-state/identity/hooks';

interface IHeaderProps {
    onRenderDocumentPicker?: (textColor?: string, isLowerTopBar?: boolean) => ReactElement;
}
const Header: React.FC<IHeaderProps> = ({ onRenderDocumentPicker }) => {
    const { smallDevice, mediumDevice } = useWindowWidth();
    const [identity] = useIdentityClaims();
    const isVisitor = identity?.roles.includes('visitor') || identity?.roles.includes('auto-confirmed-visitor') ? true : false;
    return (
        <>
            <TopBar>{(textColor: string, isLowerTopBar?: boolean) => onRenderDocumentPicker && onRenderDocumentPicker(textColor, isLowerTopBar)}</TopBar>
            {!smallDevice && !mediumDevice && !isVisitor && (
                <LowerTopBar>
                    {(textColor: string, isLowerTopBar?: boolean) => onRenderDocumentPicker && onRenderDocumentPicker(textColor, isLowerTopBar)}
                </LowerTopBar>
            )}
            <HelpModal />
            <IdentityPanel />
        </>
    );
};
export default Header;
